// extracted by mini-css-extract-plugin
export default {"Confirmation":"GaleryModal_Confirmation__v-o37","box":"GaleryModal_box__QwgSf"};